import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import EntityId = com.eidu.sharedlib.entity.EntityId

type DeleteEntityParameters = { id: EntityId }

const deleteEntity = async ({ id }: DeleteEntityParameters) => {
  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${id.toString()}`,
    {
      method: 'DELETE',
    }
  )
  if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from deleteEntity endpoint`)
}

export default deleteEntity
